import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Box,
  Flex,
  Button,
  Center,
  Editable,
  EditableInput,
  EditablePreview,
} from "@chakra-ui/react";
import {
  setEditingMode,
  setFormDescription,
  updateDroppedItems,
  setFormTitle,
} from "../../redux/actions/formActions";
import FirstName from "./Fields/FirstName";
import LastName from "./Fields/LastName";
import Email from "./Fields/Email";
import Phone from "./Fields/Phone";
import Address from "./Fields/Address";
import TextField from "./Fields/TextField";
import Url from "./Fields/Url";
import Paragraph from "./Fields/Paragraph";
import Rating from "./Fields/RatingStar/Rating";
import Number from "./Fields/Number";
import DropDown from "./Fields/DropDown";
import CheckBox from "./Fields/CheckBox";
import Droppable from "./Droppable";
import ModalFormPreview from "../Common/ModalFormPreview";
import FormPreview from "./PreviewAndEmbed/FormPreview";
import PreviewDragField from "./PreviewDragField";
import PreviewEyeIcon from "./Icons/PreviewEye";

const BuildForm = (props) => {
  const {
    title,
    description,
    dropped,
    isFocused,
    dispatchSetEditingMode,
    dispatchSetFormTitle,
    dispatchSetFormDescription,
    submitConfig,
    dispatchUpdateDroppedItems,
    currentTemplate,
  } = props;
  const [previewMode, setPreviewMode] = useState(false);
  const handleOnClickSubmitBtn = (e) => {
    e.preventDefault();
    dispatchSetEditingMode(submitConfig.uid, "BUTTON");
  };
  const handleOnTitleChange = (title) => {
    dispatchSetFormTitle(title);
  };
  const handleOnDescriptionChange = (description) => {
    dispatchSetFormDescription(description);
  };
  const onClickPreviewHandler = (e) => {
    e.preventDefault();
    setPreviewMode(true);
  };
  const handlePreviewModeClose = (onClose) => {
    setPreviewMode((isToggled) => !isToggled);
    onClose();
  };

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const dragField = dropped[dragIndex];
      const sortFields = dropped.filter((field) => field.uid !== dragField.uid);
      sortFields.splice(hoverIndex, 0, dragField);
      console.log("dispatchUpdateDroppedItems", sortFields, dropped);
      dispatchUpdateDroppedItems(sortFields);
    },
    [dropped]
  );

  const renderPreviewForm = () => {
    return (
      previewMode && (
        <ModalFormPreview
          shouldOpen={previewMode}
          handlePreviewModeClose={handlePreviewModeClose}
        >
          <Box bg="background.secondary" m="0 auto" w="100%" boxShadow="lg">
            <FormPreview previewMode={previewMode} formWidth={"100%"} />
          </Box>
        </ModalFormPreview>
      )
    );
  };
  return (
    <Box
      bg="#fff"
      borderRadius="sm"
      mt="16px"
      mr="150px"
      p="24px"
      minH="392px"
      w="640px"
    >
      {renderPreviewForm()}
      <Flex direction="column" justify="space-between" minH="300px">
        <Box w="592px" mb="12px" h="32px">
          <div>
            <Button
              display="flex"
              float="right"
              w="107px"
              h="32px"
              bg="linear-gradient(180deg, #FFFFFF 0%, #F5F7F9 100%)"
              style={{ borderRadius: "4px", border: "1px solid #CFD7DF" }}
              fontSize="14px"
              fontWeight="600"
              color="#12344D"
              onClick={onClickPreviewHandler}
            >
              <div style={{ marginRight: "8px" }}>
                <PreviewEyeIcon />
              </div>
              Preview
            </Button>
          </div>
        </Box>
        <Droppable>
          {/* header */}
          <Box>
            <Editable
              defaultValue={
                title == "Add a form title" ? currentTemplate.title : title
              }
              fontSize="18px"
              fontWeight="600"
              color="#12344D"
              w="100%"
              h="36px"
              mb="4px"
              borderRadius="4px"
              onChange={handleOnTitleChange}
            >
              <EditablePreview w="100%" className="dasboard-form__title" />
              <EditableInput w="100%" />
            </Editable>

            <Editable
              fontSize="14px"
              color="#12344D"
              h="32px"
              borderRadius="4px"
              defaultValue={description}
              w="100%"
              mb="12px"
              onChange={handleOnDescriptionChange}
            >
              <EditablePreview w="100%" className="dasboard-form__title" />
              <EditableInput w="100%" />
            </Editable>

            <Box>
              <ul className="list">
                {dropped &&
                  dropped.map((v, index) => {
                    if (v.type === "firstName") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <FirstName
                            preview={false}
                            text={v.text}
                            uid={v.uid}
                          />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "lastName") {
                      return (
                        <PreviewDragField
                          key={v.uid}
                          index={index}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <LastName preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "email") {
                      return (
                        <PreviewDragField
                          key={v.uid}
                          index={index}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <Email preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "phone") {
                      return (
                        <PreviewDragField
                          key={v.uid}
                          index={index}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <Phone preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "address") {
                      return (
                        <PreviewDragField
                          key={v.uid}
                          index={index}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <Address preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "textField") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <TextField
                            preview={false}
                            text={v.text}
                            uid={v.uid}
                          />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "url") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <Url preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "paragraph") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <Paragraph
                            preview={false}
                            text={v.text}
                            uid={v.uid}
                          />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "rating") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <Rating preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "number") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <Number preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "dropDown") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <DropDown preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                    if (v.type === "checkBox") {
                      return (
                        <PreviewDragField
                          index={index}
                          key={v.uid}
                          moveCard={moveCard}
                          id={v.uid}
                        >
                          <CheckBox preview={false} text={v.text} uid={v.uid} />
                        </PreviewDragField>
                      );
                    }
                  })}
              </ul>
            </Box>

            <Center
              border="2px"
              borderStyle="dashed"
              borderColor="#CFD7DF"
              borderRadius="4px"
              minH="60px"
            >
              Drag and drop to add form fields
            </Center>
          </Box>
        </Droppable>

        {/* footer */}
        <Box mt="3">
          <Box
            p="3"
            cursor="pointer"
            borderRadius="sm"
            border={isFocused ? "2px solid #3182ce" : "none"}
            bg="#F5F7F9"
            display="table"
            onClick={handleOnClickSubmitBtn}
          >
            <Button size="sm" colorScheme="blue">
              {submitConfig.name}
            </Button>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

BuildForm.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  dropped: PropTypes.array.isRequired,
  isFocused: PropTypes.bool.isRequired,
  dispatchSetEditingMode: PropTypes.func.isRequired,
  dispatchSetFormTitle: PropTypes.func.isRequired,
  dispatchSetFormDescription: PropTypes.func.isRequired,
  submitConfig: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const { isEditing, submitConfig, focusField } = state.form;
  return {
    dropped: state.form.dropped,
    currentTemplate: state.templates.currentTemplate,
    title: state.form.title,
    description: state.form.description,
    submitConfig,
    isFocused: isEditing && focusField.uid == submitConfig.uid,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetEditingMode: bindActionCreators(setEditingMode, dispatch),
    dispatchSetFormTitle: bindActionCreators(setFormTitle, dispatch),
    dispatchUpdateDroppedItems: bindActionCreators(
      updateDroppedItems,
      dispatch
    ),
    dispatchSetFormDescription: bindActionCreators(
      setFormDescription,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildForm);
